/* ============
 * Locale
 * ============
 *
 * For a multi-language application
 */

import { getAppLang, defaultLang } from '@/utils/cookie-helper';
import en from './en';
import tr from './tr';

const lang = {
  config: {
    locale: getAppLang() || defaultLang(),
    fallbackLocale: 'tr',
  },
  locales: {
    en,
    tr,
  },
  datetimeFormats: {
    en: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
      },
    },
    tr: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
      },
    },
  },
};

export default lang;
